export default __webpack_public_path__ + "static/media/flux-capacitor10fps.fb544303.gif";